import { render, staticRenderFns } from "./available-meds-dialog.vue?vue&type=template&id=8940fb9a&scoped=true"
import script from "./available-meds-dialog.vue?vue&type=script&lang=js"
export * from "./available-meds-dialog.vue?vue&type=script&lang=js"
import style0 from "./available-meds-dialog.vue?vue&type=style&index=0&id=8940fb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8940fb9a",
  null
  
)

/* custom blocks */
import block0 from "@/locale/nurse-localization.json?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CUsers%5Cnikod%5CDocuments%5Cgithub%5Cnikodz%5CWebmed.Core.VueJS%5Csrc%5Ccomponent%5Cnurse%5Cavailable-meds-dialog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports